/**
 * View component for /admin/authoring/sponsors/:sponsorId
 *
 * Displays a single sponsor from the 'byId' map in the sponsor reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as sponsorActions from '../sponsorActions';
import * as studyActions from '../../study/studyActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from '../../../global/components/BaseComponent.js.jsx';
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import module components
import AdminSponsorStudyListItem from '../../study/components/AdminSponsorStudyListItem.js.jsx';

// import utilities
import filterUtils from '../../../global/utils/filterUtils';

// import sponsor css modules
import sponsorStyles from '../sponsorModuleStyles.css';

class AdminSingleSponsor extends Base {
  constructor(props) {
    super(props);
    this.state = {
      confirmSendEmailsModalOpen: false
    }
    this._bind(
      '_sendRemindersBySponsor'
    )
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(sponsorActions.fetchSingleIfNeeded(match.params.sponsorId));
    dispatch(studyActions.fetchListIfNeeded('_organization', match.params.sponsorId));
  }

  _sendRemindersBySponsor() {
    const { dispatch, match } = this.props;
    dispatch(sponsorActions.sendRemindersBySponsor({id: match.params.sponsorId}))
    this.setState({
      confirmSendEmailsModalOpen: false
    })
  }

  render() {
    const { history, location, sponsorStore, studyStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual sponsor object from the map
     */
    const selectedSponsor = sponsorStore.selected.getItem();
    const studyListItems = studyStore.util.getList('_organization', this.props.match.params.sponsorId);

    const isEmpty = (
      !selectedSponsor
      || !selectedSponsor._id
      || sponsorStore.selected.didInvalidate
      || !studyListItems
    );

    return (
      <div className="flex">
        <section className="section">
          <div className="yt-container">
            <Breadcrumbs links={location.state.breadcrumbs} />
            { isEmpty ?
                (sponsorStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
                <div style={{ opacity: sponsorStore.isFetching ? 0.5 : 1 }}>
                  <div className="yt-row with-gutters">
                    <div className="yt-col full s_60">
                      <div className="content-container">
                        <div className="yt-row space-between">
                          <div>
                            <Link className="yt-btn x-small" to={`${this.props.match.url}/update`}> Update Sponsor Info</Link>
                            <Link
                              className="yt-btn x-small warning"
                              to={`/admin/audit-logs/sponsor/${selectedSponsor._id}`}
                              target="_blank"
                            > 
                              Object History &rarr;
                            </Link>
                          </div>
                        </div>
                        <hr/>
                        <h3>General Sponsor Info</h3>
                        <h2>{ selectedSponsor.name }</h2>
                        <div style={{maxWidth: '200px', marginTop: '32px'}}>
                          <p><strong>Logo:</strong></p>
                          <img src={selectedSponsor.logo ? selectedSponsor.logo : "/img/yt_logo.png"} />
                        </div>
                        { selectedSponsor.authToken ? 
                          <div>
                            <p>Authorization token (for third party invites):</p>
                            <div className="yt-row">
                              <p><strong>{selectedSponsor.authToken}</strong></p>
                              <button className="yt-btn x-small link info" onClick={() => {navigator.clipboard.writeText(selectedSponsor.authToken)}}>Copy</button>
                            </div>
                          </div>
                          : null
                        }
                      </div>
                    </div>
                    <div className="yt-col full s_40">
                      <div className="content-container">
                        <div className="yt-row space-between">
                          <p><strong>Sponsor's studies</strong></p>
                          {/* <button className="yt-btn x-small warning" onClick={() => this.setState({confirmSendEmailsModalOpen: true})}>Send reminders for all listed studies</button> */}
                        </div>
                        <hr/>
                        <div className="-quick-list">
                          {studyListItems.map((study, i) =>
                            <AdminSponsorStudyListItem key={study._id} study={study} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            }
          </div>
          <AlertModal
            alertMessage={<div> Are you <em>sure</em> you want to send an email to all active study users for all listed studies that have reminders turned on?</div> }
            alertTitle="Send reminders for all sponsor studies"
            closeAction={() => this.setState({confirmSendEmailsModalOpen: false})}
            confirmAction={this._sendRemindersBySponsor}
            confirmText="Yes, send emails"
            declineText="Never mind"
            isOpen={this.state.confirmSendEmailsModalOpen}
            type="warning"
          />
        </section>
      </div>
    )
  }
}

AdminSingleSponsor.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    currentUser: store.user.loggedIn.user
    , sponsorStore: store.sponsor
    , studyStore: store.study
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminSingleSponsor)
);



// WEBPACK FOOTER //
// modules/sponsor/views/AdminSingleSponsor.js.jsx